import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { pageComponentsByKey } from '../../config/pages';
import { WmsLayout } from '../layout/layout';
import { WmsBlockRenderer } from '../block-renderer/block-renderer';
import { CreateElement } from 'vue';
import { BlockDTO } from '../../model/BlockDTO';
import { Dictionary } from '../../types/Dictionary';

import { groupBy } from 'lodash-es';

@Component({
	components: {
		WmsLayout,
		WmsBlockRenderer
	}
})
export class WmsPageComposer extends Vue {
	@Prop() pageUrl: string;
	@Prop() pageTemplate: string;

	@Watch('$route', {immediate: true, deep: true})
	routeChanged(newRoute: any, oldRoute: any) {
		console.log("route changed", newRoute, oldRoute, this.pageComponent);
		if (!oldRoute || !this.pageTemplate || (this.pageComponent as any).needsRefetch(oldRoute, newRoute)) {
			this.fetchPage();
		}
	}

	@Watch('$store.langId')
	langChanged() {
		this.$store.fetchComponentsPage();
		this.fetchPage();
	}

	get pageComponent() {
		if (!this.pageTemplate && !this.$store.page) {
			return null;
		}

		return pageComponentsByKey[this.pageTemplate || this.$store.page.template];
	}

	get blocksByColumn(): Dictionary<BlockDTO[]> {
		if (!this.$store.page) {
			return {};
		}

		return groupBy(this.$store.page.blocks, 'column');
	}

	protected fetchPage() {
		this.$store.fetchPage(this.pageUrl, this.pageTemplate);
	}

	render(c: CreateElement) {
		if (!this.$store.componentsPageIsLoaded || !this.pageComponent) {
			return this.renderLoading(c);
			return null;
		}

		console.log("component", this.pageComponent);

		const layout = (this.pageComponent as any).layout;

		if (layout) {
			return c(layout, [
				this.renderPage(c)
			]);
		} else {
			return this.renderPage(c);
		}

	}

	renderPage(c: CreateElement) {
		if (!this.$store.pageIsLoaded) {
			return this.renderLoading(c);
			return null;
		}

		console.log("BLOCKS", this.blocksByColumn);

		return c(this.pageComponent,
			Object.keys(this.blocksByColumn).map(column => {
				return c('div', {slot: `column-${column}`},
					this.blocksByColumn[column].map(block =>
						c(WmsBlockRenderer, {
							props: {
								block
							},
							key: block.id
						})
					)
				)
			})
		);
	}

	renderLoading(c: CreateElement) {
		return c('div', {
			class: 'spinner spinner--fixed'
		});
	}
}

export default WmsPageComposer;
